import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { PageStatus } from 'Containers/Urls';
import useProtectedApplication from 'Hooks/useProtectedApplication';
import { DOMAIN, FEATURE, LoggerFactory } from 'Services/Logger';

import { useFunnelParams } from './useFunnel.models';
import { usePusher } from './usePusher';

const logger = LoggerFactory.getLogger(DOMAIN.B2C);

export const useFunnel = ({
  routeStatus,
} : useFunnelParams) => {
  const history = useHistory();
  const {
    data: application,
    refetch: refetchApplication,
  } = useProtectedApplication();

  usePusher({ routeStatus });

  // Go to correct status if pager is linked to a routeStatus
  const serverStatus = application?.status;
  useEffect(() => {
    if (!serverStatus) return;
    if (routeStatus && routeStatus !== serverStatus) {
      logger.info(
        `Funnel wrapper: Redirect application from ${routeStatus} to ${PageStatus[serverStatus]}`,
        `${DOMAIN.B2C}.${FEATURE.FUNNEL}`,
      );
      history.replace(PageStatus[serverStatus]);
    }
  }, [serverStatus]);

  // For direct redirection to an url
  useEffect(() => {
    if (!routeStatus) return;
    if (routeStatus !== serverStatus) {
      refetchApplication();
    }
  }, [routeStatus]);

  return { application };
};
